import { defineStore } from 'pinia'

import { Ad } from '@/common/models/data/dashboard/ads'
import AdsRepository from '@/app/repositories/ads-repository'

const useAdsStore = defineStore('ads', {
    state: () => ({
        ads: [] as Array<Ad>
    }),
    actions: {
        async load (): Promise<void> {
            this.ads = await AdsRepository.all()
        }
    }
})

export {
    useAdsStore
}
